import React, { useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Typography,
  Paper,
  CircularProgress,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { getPersonality, getScoreBand, getTopicScore } from "../../redux/actions/appActions";
import { Button } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ROUTE_COMPLETE_PROFILE } from "../../constants/routes";
import { getApplicantDetails } from "../../redux/actions/b2bActions";

const FloatingButton = () => {
  const navigate = useNavigate();
  return (
    <Button
      variant="contained"
      color="primary"
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        borderRadius: "50px",
        padding: "10px 20px",
        boxShadow: "0px 3px 5px rgba(0,0,0,0.2)",
        textTransform: "none",
        backgroundColor: "#756DE9",
        "@media print": {
          display: "none",
        },
      }}
      onClick={() => {
        // Add your navigation logic here
        navigate(ROUTE_COMPLETE_PROFILE);
      }}
    >
      Go to Dashboard
    </Button>
  );
};

const PersonalityProfiler = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const ajaxCallsInProgress = useSelector((state: any) => state.ajaxCallsInProgress);
  const user = useSelector((state: any) => state.app.user);
  const { applicantDetails } = useSelector((state: any) => state.b2b);
  const personality = useSelector((state: any) => state.app.personality);
  const topicScore = useSelector((state: any) => state.app.topicScore);
  const scoreBand = useSelector((state: any) => state.app.scoreBand);
  const { userDetail } = applicantDetails;
  const applicantId = searchParams.get("applicant_id");

  const { fullName } = user?.user || {};
  const { fullName: applicantName } = userDetail || {};

  useEffect(() => {
    const applicantId = searchParams?.get("applicant_id");
    if (applicantId) {
      dispatch(getApplicantDetails(applicantId));
      dispatch(getPersonality(applicantId));
      dispatch(getTopicScore(applicantId));
      dispatch(getScoreBand(applicantId));
    } else {
      dispatch(getPersonality());
      dispatch(getTopicScore());
      dispatch(getScoreBand());
    }
  }, []);

  const printPdf = () => {
    window.print();
  };

  if (ajaxCallsInProgress) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", height: "100vh", alignItems: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#ffffff",
        fontFamily: "'Poppins', sans-serif",
        overflow: "hidden", // Hide overflow to prevent scrolling
        boxSizing: "border-box",
      }}
    >
      {applicantId ? null : <FloatingButton />}

      <Box
        style={{
          backgroundColor: "#000000",

          textAlign: "center",
          borderRadius: "10px",
          width: "100%",
          marginBottom: "20px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-around",
          padding: "20px",
        }}
      >
        <Typography variant="h4" style={{ fontSize: "16px", color: "#fff" }}>
          {applicantId ? applicantName?.split(" ")?.[0] : fullName?.split(" ")?.[0]}&apos;s Personality Type. PDF
        </Typography>
        <Box onClick={printPdf}>
          <img src="images/download-line.png" alt="" width="24px" />
        </Box>
      </Box>

      <Box
        style={{ backgroundColor: "#E6E4FE", padding: "20px", textAlign: "center", borderRadius: "10px", width: "80%" }}
      >
        <Typography variant="h4" sx={{ fontWeight: "600", fontSize: "22px", color: "#1F2235", textAlign: "center" }}>
          WorkWise Personality Profiler
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: "500", fontSize: "16px", color: "#1F2235", textAlign: "center" }}>
          {applicantId ? applicantName : fullName}
        </Typography>
      </Box>

      <Box
        style={{
          padding: "20px 20px 0 20px",
          textAlign: "center",
          borderRadius: "10px",
          // backgroundImage: 'url("images/seevi-logo-new.png")',
          backgroundSize: "contain",
          backgroundPosition: "center",
          width: "80%",
        }}
      >
        {/* <Typography
          variant="h6"
          sx={{ fontWeight: "500", fontSize: "16px", color: "#1F2235", textAlign: "center" }}
          m={2}
        >
          {applicantId ? applicantName?.split(" ")?.[0] : fullName?.split(" ")?.[0]}&apos;s Personality Type
        </Typography> */}
        <Typography
          variant="h4"
          sx={{ marginBottom: "10px", fontWeight: "600", fontSize: "22px", color: "#1F2235", textAlign: "center" }}
        >
          {personality
            ?.map((el: any) => el?.displayPersonalityType)
            .reduce((acc: string[], curr: string, index: number, arr: string[]) => {
              if (arr.length === 2 && index === 1) {
                // Handle two items specifically
                return [...acc, "and " + curr];
              }
              if (index === arr.length - 1 && arr.length > 1) {
                return [...acc, "and " + curr];
              }
              return [...acc, curr];
            }, [])
            .join(personality.length === 2 ? " " : ", ")}
        </Typography>
        <img src="images/profiler-image.png" alt="" width="200px" />
      </Box>

      <Box>
        {personality?.map((el: any, idx: any) => {
          return (
            <Box key={idx}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: 1,
                  backgroundImage: 'url("images/seevi-logo-new.png")',
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  padding: "20px",
                }}
              >
                <Box component="img" sx={{ height: 200 }} src={el?.imagePath} />
              </Box>
              <Box
                sx={{
                  backgroundColor: "#F5F6FA",
                  padding: "20px",
                  borderRadius: "10px",
                  backgroundImage: 'url("images/seevi-logo-new.png")',
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  margin: "20px",
                }}
              >
                <img src="images/File-vector.png" alt="" width="24px" />

                <React.Fragment>
                  <Typography style={{ fontSize: "16px", fontWeight: "500", color: "#000" }} mt={1} mb={1}>
                    {el?.displayPersonalityType}
                  </Typography>
                  {el.typeDescriptors?.split("\n").map((detail: string, index: number) => (
                    <Typography key={index} style={{ fontSize: "14px", fontWeight: "400", color: "#000000" }}>
                      {detail}
                    </Typography>
                  ))}
                </React.Fragment>
              </Box>
              <Box
                key={el?.displayPersonalityType}
                component="div"
                sx={{
                  backgroundColor: "#F5F6FA",
                  padding: "20px",
                  borderRadius: "10px",
                  backgroundImage: 'url("images/seevi-logo-new.png")',
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  marginTop: "10px",
                  marginX: "20px",
                  marginBottom: "20px",
                }}
              >
                <img src="images/Briefcase-Vector.png" alt="" width="24px" />
                <Typography style={{ fontSize: "16px", fontWeight: "500", color: "#000" }} mt={1} mb={1}>
                  Career avenues {el?.displayPersonalityType} will excel:
                </Typography>
                {el?.careerAvenues?.map((detail: string, index: number) => (
                  <Typography key={index} style={{ fontSize: "14px", fontWeight: "400", color: "#000000" }}>
                    {detail}
                    <br></br>
                  </Typography>
                ))}
              </Box>
            </Box>
          );
        })}
      </Box>

      <Box>
        <TableContainer component={Paper}>
          <Table sx={{ border: "1px solid #000000" }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ backgroundColor: "#263238", color: "white", border: "1px solid #000000" }}>
                  <Typography variant="h6" sx={{ pl: 2 }}>
                    Skills and Traits Factors
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{ backgroundColor: "#263238", color: "white", border: "1px solid #000000" }}
                  align="center"
                >
                  <Typography variant="h6">Scores</Typography>
                </TableCell>
                <TableCell
                  sx={{ backgroundColor: "#263238", color: "white", border: "1px solid #000000" }}
                  align="center"
                >
                  <Typography variant="h6">Grade</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {topicScore.map((row: any, index: any) => (
                <TableRow key={index} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                  <TableCell component="th" scope="row" sx={{ pl: 2, borderRight: "1px solid #E0E0E0" }}>
                    <Typography variant="subtitle1" sx={{ pl: 2, fontWeight: "bold" }}>
                      {row.topic}
                    </Typography>
                    <Typography variant="body2" sx={{ pl: 2 }}>
                      {row.descriptors}
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={{ borderRight: "1px solid #E0E0E0" }}>
                    <Typography variant="subtitle1">{row.percentile}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Box
                      sx={{
                        backgroundColor:
                          row?.scoringBand === "High" ? "#00C853" : row?.scoringBand === "Low" ? "#D50000" : "#2196F3",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        color: "white",
                        display: "inline-block",
                      }}
                    >
                      <Typography variant="subtitle1">{row.scoringBand}</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box sx={{ width: "100%", paddingLeft: "40px" }}>
        <Typography style={{ fontSize: "28px", fontWeight: "700", color: "#000" }} mt={3} mb={1}>
          Verification Scores
        </Typography>
        {}
        <TableContainer component={Paper} sx={{ border: "1px solid #E0E0E0", borderRadius: "8px", width: "90%" }}>
          <Table>
            <TableBody>
              {[
                { label: "Low social desirability", status: "check" },
                { label: "Moderate social desirability", status: "close" },
                { label: "High social desirability", status: "close" },
                { label: "Invalid profile", status: "close" },
              ].map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ borderBottom: index < 3 ? "1px solid #E0E0E0" : "none", padding: "12px 16px" }}>
                    <Typography variant="body1">{item.label}</Typography>
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ borderBottom: index < 3 ? "1px solid #E0E0E0" : "none", padding: "12px 16px" }}
                  >
                    {item.label?.toLocaleLowerCase() === scoreBand?.[0]?.scoringBand?.toLocaleLowerCase() ? (
                      <CheckIcon sx={{ color: "#00C853" }} />
                    ) : (
                      <CloseIcon sx={{ color: "#E0E0E0" }} />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box
        sx={{
          backgroundColor: "#FFEBEE",
          padding: "16px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          width: "85%",
          marginTop: "20px",
        }}
      >
        <img src="images/Alarm-Vector.png" alt="" width="24px" />
        <Typography variant="body1" sx={{ color: "#FF7043", marginTop: "20px" }}>
          {scoreBand?.[0]?.descriptors}
        </Typography>
      </Box>
    </Box>
  );
};

export default PersonalityProfiler;
